import type { SVGProps } from 'react'

const LineEmail = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={20}
		height={20}
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="m1.667 5 5.76 3.264c2.124 1.203 3.021 1.203 5.145 0L18.333 5M7.583 2.947a97 97 0 0 1 4.835 0c2.623.066 3.935.099 4.878 1.045.942.946.97 2.224 1.024 4.778a56 56 0 0 1 0 2.46c-.054 2.554-.082 3.831-1.024 4.778s-2.255.979-4.878 1.045a98 98 0 0 1-4.836 0c-2.624-.066-3.935-.1-4.878-1.045-.943-.947-.97-2.224-1.024-4.778a58 58 0 0 1 0-2.46c.054-2.554.081-3.832 1.024-4.778s2.254-.98 4.878-1.045"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
export { LineEmail }
